/**
 * Caminhos de rota centralizados. Manter os literais aqui — e não espalhados pelas
 * páginas — deixa a navegação legível e isola o app do react-router: o
 * `@ionic/react-router` prende a versão no v5, então o dia da troca de router edita
 * este módulo e o `useAppNavigation`, não cada tela.
 */
export const ROUTES = {
  login: '/login',
  dashboard: '/',
  emitir: '/emitir',
  notas: '/notas',
  /** Padrão do `<Route>`; para navegar até uma nota concreta use `notaPath(id)`. */
  notaDetalhe: '/notas/:id',
  empresa: '/empresa',
  /** Equipe da empresa em operação; exige `company_users` `FULL` (papel de administrador). */
  empresaUsuarios: '/empresa/usuarios',
  empresaUsuariosConvidar: '/empresa/usuarios/convidar',
  /**
   * Padrão do `<Route>`; para navegar até um vínculo use `empresaUsuarioPath(id)`. O `:id` só
   * casa dígitos, senão `/empresa/usuarios/convidar` também seria um vínculo — e o
   * `IonRouterOutlet` fica com a **última** rota que casa (`matchRoute`), não com a primeira.
   */
  empresaUsuario: '/empresa/usuarios/:id(\\d+)',
  perfil: '/perfil',
  /** Feed de documentos da empresa em operação (E14); exige `documents` `READ`. */
  documentos: '/documentos',
  /** Pastas por seção, tipo e período; mesmo guarda do feed. */
  documentosPastas: '/documentos/pastas',
  /** As guias da empresa em operação (E16): em aberto, vencidas e pagas; `documents` `READ`. */
  impostos: '/impostos',
  /** Pública: o token do e-mail é a credencial, e a conta ainda não existe. */
  convite: '/convite/:token',
} as const;

/**
 * O parâmetro com que um push abre a tela de uma empresa (`/impostos?empresa=<id>`, decisão 6 de
 * E16): a tela seleciona essa empresa quando o usuário a tem (`useCompanyFromUrl`).
 */
export const COMPANY_PARAMETER = 'empresa';

export function companyPath(path: string, clientId: number): string {
  return `${path}?${COMPANY_PARAMETER}=${clientId}`;
}

export function notaPath(id: string): string {
  return `/notas/${id}`;
}

export function convitePath(token: string): string {
  return `/convite/${token}`;
}

export function empresaUsuarioPath(id: number): string {
  return `/empresa/usuarios/${id}`;
}
